import { Component, OnInit } from '@angular/core';
import { InfohashService } from './infohash.service';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-infohash',
  templateUrl: './infohash.component.html',
  styleUrls: ['./infohash.component.scss']
})
export class InfohashComponent implements OnInit {

  infohashes;
  rawResult;
  contentIdSelection = [];
  notificationTitle: any;
  notificationContent: any;
  notificationType: any;
  loading = true;

  constructor(private _service: NotificationsService, private infohashService: InfohashService,
  ) { }

  ngOnInit() {
    this.getInfohash();
  }


  getInfohash() {
    this.loading = true;
    this.infohashService.getInfohash().then(res => {
      this.infohashes = res.infohashes;
      this.rawResult = res;
      this.loading = false;
    }).catch(error => this.errorHandler(error));
    // console.log(this.infohashes);
  }


  errorHandler(error: any) {
    this.notificationType = 'error';
    this.notificationTitle = 'Error';
    if (error._body !== undefined) {
      const jsonErrorBody = JSON.parse(error._body);
      this.notificationContent = jsonErrorBody.error.message;
    } else {
      this.notificationContent = error;
    }
    this.loading = false;
    this.createNotification();
  }

  redirect(content_id: string) {
    this.loading = true;
    this.infohashService.updateMapping(content_id, this.rawResult).then(res => this.getInfohash()).catch(error => this.errorHandler(error));
    // console.log(this.infohashes);
  }

  skip() {
    this.loading = true;
    this.infohashService.updateMapping('false', this.rawResult).then(res => this.getInfohash()).catch(error => this.errorHandler(error));
    // console.log(this.infohashes);
  }


  createNotification() {
    switch (this.notificationType) {
      case 'success':
        this._service.success(this.notificationTitle, this.notificationContent);
        break;
      case 'error':
        this._service.error(this.notificationTitle, this.notificationContent);
        break;
      case 'info':
        this._service.info(this.notificationTitle, this.notificationContent);
        break;
    }
  }
  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };
}



// WEBPACK FOOTER //
// ./src/app/catalogue/infohash/infohash.component.ts